<template>
    <div>
        <base-header type="primary" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid pt-4">
            <button @click="changeFilter('all')" type="button" v-bind:class="{'btn btn-primary text-white mt-1': filter!='all', 'btn btn-outline-primary mt-1': filter=='all'}">
                Show all users
            </button>
            <button @click="changeFilter('leads')" type="button"  v-bind:class="{'btn btn-primary text-white mt-1': filter!='leads', 'btn btn-outline-primary mt-1': filter=='leads'}">
                Leads
            </button>
            <button @click="changeFilter('customers')" type="button"  v-bind:class="{'btn btn-primary text-white mt-1': filter!='customers', 'btn btn-outline-primary mt-1': filter=='customers'}">
                Customers
            </button>

            <div class="row mt-3">
                <table class="table tablesorter hover table-hover">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item) in sortedList" :key="item['.key']">
                            <td>
                                <router-link :to="{ name: 'user details', params: { id: item.id } }"
                                             class="text-dark font-weight-normal text-uppercase">
                                    {{item.id}}
                                </router-link>
                            </td>
                            <td>
                                {{item.name}}
                            </td>
                            <td>
                                {{item.phone}}
                            </td>
                            <td>
                                <div class="align-middle d-flex justify-content-start">
                                    <router-link :to="{ name: 'user details', params: { id: item.id } }"
                                                 class=" btn btn-sm btn-primary btn-icon-only rounded-circle mt-1">
                                        <i class="fa fa-eye"></i>
                                    </router-link>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>

    window.$ = window.jQuery = require('jquery');
    import firebase from '../config/db.js';

    export default {
        name: 'users',
        data() {
            return {
                filter: 'all',
                list: [],
                publicPath: process.env.BASE_URL,
            }
        },
        mounted: function () {
            this.getFormList();
        },
        computed: {
            sortedList: function () {
                switch (this.filter) {
                    case 'leads': return this.list.filter(function (elem) {
                        if (elem.name === "N/A") return true;
                        else return false;
                    });
                    case 'customers': return this.list.filter(function (elem) {
                        if (elem.name !== "N/A") return true;
                        else return false;
                    });
                    default: return this.list;
                }
            }
        },
        methods: {
            getFormList: function () {
                var collection = [];
                firebase.firestore().collection("users").get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        let firstName = doc.data().firstName ? doc.data().firstName : "";
                        let lastName = doc.data().lastName ? doc.data().lastName : "";

                        collection.push({
                            id: doc.id,
                            name: firstName || lastName ? firstName + " " + lastName : "N/A",
                            phone: doc.data().phone ? doc.data().phone : "N/A"
                        });
                    });
                });
                this.list = collection;
            },
            changeFilter: function (type) {
                this.filter = type;
            }
        }
    };
</script>

